module.exports = __webpack_public_path__ + "img/img-avatar08.71e2eeed.jpg";